import { Delete } from 'lucide-react';

export default function PINKeyboard({ onNumberClick, onBackspace, onClear }) {
  const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

  return (
    <div className="grid grid-cols-3 gap-2 w-full max-w-[240px] mx-auto">
      {numbers.map((num) => (
        <button
          key={num}
          onClick={() => onNumberClick(num)}
          className="h-12 bg-white/10 hover:bg-white/20 rounded-lg text-xl font-bold transition-colors active:scale-95"
        >
          {num}
        </button>
      ))}
      <button
        onClick={onClear}
        className="h-12 bg-red-500/20 hover:bg-red-500/30 rounded-lg text-xs font-semibold transition-colors active:scale-95"
      >
        Clear
      </button>
      <button
        onClick={onBackspace}
        className="h-12 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors active:scale-95"
      >
        <Delete size={20} />
      </button>
    </div>
  );
}
